import gql from 'graphql-tag';

export const InAppNotificationsQuery = gql`
  query inAppNotifications($endCursor: String) {
    inAppNotifications(endCursor: $endCursor) {
      notifications {
        notificationId
        topic
        body {
          message
        }
        actionLink
        createdAt
        readDate
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const ReadNotificationMutation = gql`
  mutation readNotification($notificationId: String!) {
    readNotification(notificationId: $notificationId) {
      notificationId
      readDate
    }
  }
`;
